import type React from 'react';

export type ControlWidth = string | number;

// `'auto'` is `MultiSelect`'s default and means "no width asked for", so it is passed over
// rather than clamped: `max-width: 100%` on a control nobody sized is a change to every one
// of them, and `width: auto` is the block default anyway.
export const controlWidthStyle = (width?: ControlWidth): React.CSSProperties | undefined =>
    width === undefined || width === 'auto'
        ? undefined
        : { width: typeof width === 'number' ? `${width}px` : width, maxWidth: '100%' };
